// @ts-nocheck
/* eslint-disable no-unused-vars */
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';

export const SelectInventory = ({ value, onChange }) => {
  const { InventoryOptions, loading } = useGetInventoryWithPermission();
  const { t, i18n } = useTranslation();

  return (
    <>
      <Select
        classNamePrefix='react-select'
        isLoading={loading}
        isSearchable={true}
        isClearable
        options={InventoryOptions}
        value={InventoryOptions?.find(f => f.value === value)}
        onChange={onChange}
        placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
      />
    </>
  );
};
